export const RECEIVE_USERS = 'users/RECEIVE';
export const ADD_USER = 'users/ADD';
